module.exports = __webpack_public_path__ + "media/News_item_16.67bd946c.mp4";